import Pym from 'pym.js';
import { useEffect } from 'react';

export function PymFrameRuntime({ children }) {
  useEffect(function mountPymJs() {
    new Pym.Child();
  }, []);

  return children;
}
